<template>
  <div>
    <el-dialog
      title="组织架构预览"
      :fullscreen="true"
      :visible.sync="showDialog"
      class="organization"
      @close=close
    >
    <!-- 组织架构 -->
    <vo-basic :data="chartData" :zoom="false" :nodeTitle=nodeTitle></vo-basic>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 组织架构
 */
import { VoBasic } from "vue-orgchart";
export default {
  name: "organization",
  components:{VoBasic},
  props: {
    chartData: {
      type: Object,
      default:()=>{},
    },
    organizationVisible:{
      type:Boolean,
      required:true,
    },
    nodeTitle:{
      type:String,
      default:'name',
    }
  },
  data() {
    return {
      showDialog:this.organizationVisible
    };
  },
  methods: {
    close(){
      this.$emit('update:organizationVisible',false)
    }
   
  },
  created(){
  }
};
</script>
<style lang='scss' >
 .organization #chart-container{
   overflow-x: auto;
   height:580px;
   &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
      height: 10px;
      }
     &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius   : 10px;
      background-color:#c9dff7;
      
     
      }
     &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
      background   : #fff;
      border-radius: 10px;
      }
 }
 .organization .el-dialog__body{
   max-height: none;
 }
</style>


// WEBPACK FOOTER //
// src/components/common/page/Organization.vue